"use client";

import { Hero as BumbleHero } from "@bumble/ui-kit";
import { useMediaQuery } from "@/lib/hooks/useMediaQuery";
const PLACEHOLDER_IMAGE = "/assets/placeholder-background.png";
export default function Hero({
  data
}: any) {
  const {
    title = "",
    description = "",
    backgroundImage,
    backgroundImageMobile,
    backgroundImageTablet,
    variation = "inverse"
  } = data;
  const isMobile = useMediaQuery(768);
  const isTablet = useMediaQuery(1024);
  const bgImage = {
    url: isMobile ? backgroundImageMobile?.url || backgroundImage?.url : isTablet ? backgroundImageTablet?.url || backgroundImage?.url : backgroundImage?.url,
    alt: isMobile ? backgroundImageMobile?.alt || backgroundImage?.alt : isTablet ? backgroundImageTablet?.alt || backgroundImage?.alt : backgroundImage?.alt
  };
  return <BumbleHero backgroundImageSrc={bgImage?.url || PLACEHOLDER_IMAGE} backgroundImageAlt={bgImage?.alt ?? "Placeholder image"} backgroundColor={undefined} words={undefined} descriptionText={undefined} animation={undefined} animationCards={undefined} ctaBox={{
    description: description ?? "",
    title: title ?? ""
  }} textColor={variation ?? "inverse"} variant="full-width-image" overlay="gradient-bottom" />;
}